import { createWebSocketStore } from 'src/components/#services/helpers';
import { isLoggedIn } from 'src/services/auth';
// region myBalance
export const myBalance = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'balance_getMyBalancesWithRounding',
        agent: 'transactions',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
    getResult(value) {
        return Object.assign(Object.assign({}, value), { data: Object.assign({}, ...value.tickers.map((x) => ({ [x.ticker]: x.amount }))) });
    },
});
// endregion
isLoggedIn.subscribe((value) => {
    myBalance.reset();
    if (value) {
        myBalance.send();
    }
});
